<template>
  <div class="checkbox-with-terms">
    <Checkbox :name="name" :value="value" @input="onChange" class="checkbox" />
    <label :for="name">
      <p class="terms">{{ terms }}</p>
    </label>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox'
export default {
  name: 'CheckboxWithTerms',
  components: {
    Checkbox,
  },
  props: {
    // Unique name that is not shared by any other input on the page
    name: {
      type: String,
      required: true,
    },
    terms: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    onChange(isChecked) {
      this.$emit('input', isChecked)
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.checkbox-with-terms {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 1rem;
}
.checkbox {
  padding: 0rem;
  margin-top: 3px;
}
.terms {
  font-size: 0.8rem;
}
</style>
